
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.42 14.65c-.048 0-.048-.048-.048-.048 0-.049 0-.488.244-.634.195-.098 1.318-.879 1.562-1.025-.098-.293-.586-1.952-.586-2.587v-2.05l-.049-.536-.83.097-2.489.83-2.244.927-.245.147H.638l-.049-.05v-.146l.195-.439s0-.146.147-.195a70.281 70.281 0 001.805-1.123c-.048-.048-.048-.146-.048-.292v-.488c0-.05 0-.196.048-.244 0 0 .05-.05.098-.05h.39s.05 0 .098.05.049.097.049.146v.537l1.757-1.074s-.098-.146-.098-.342v-.488c0-.048 0-.195.049-.244 0 0 .049-.048.098-.048h.39s.049 0 .098.048.048.098.048.147v.537l.635-.537s.195-.195.195-.488V2.255c0-.293.098-.39.195-.537s.196-.293.293-.586c.244-.683.293-.83.488-.83s.244.147.488.83c.098.293.195.488.293.586.098.146.146.244.146.44V4.89c0 .342.196.488.196.537l.634.586v-.537c0-.147.098-.195.147-.195h.39l.098.048c.048.05.048.244.048.244v.488c0 .196-.048.293-.097.342l1.757 1.074V6.94c0-.146.097-.195.146-.195h.39l.098.049c.049.048.049.244.049.244v.488c0 .146-.049.244-.049.292a70.281 70.281 0 001.806 1.123c.146.097.146.244.146.244l.195.39v.147s0 .049-.048.049h-.098l-.244-.147-2.245-.927-2.489-.83-.83-.146-.048.537v2.05c0 .634-.44 2.342-.537 2.684.244.146 1.366.927 1.562 1.024.244.147.244.586.244.635v.049h-.05l-1.903-.586-.048.342c0 .048-.05.048-.05.048v.147c0 .049-.048.049-.048.049l-.098-.05v-.146c-.048 0-.048 0-.048-.048l-.05-.342-1.951.537c.048 0 0 0 0 0z"}})])
          )
        }
      }
    